import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import { ICarrier, ICarrierCreate, ICarrierUpdate } from "./carriers.types";
const API = `${API_URL}/carriers`;

export const createCarrier = async (data: ICarrierCreate) => {
    const result = await axios.post<ICarrier>(`${API}`, data);
    return result.data;
};

export const getAllCarriers = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter,
    search?: string | null
) => {
    const url = buildUrl(API, {
        page,
        size,
        search,
        ...filter,
    });
    const result = await axios.get<Page<ICarrier>>(url);
    return result.data;
};

export const getCarrierById = async (id: number) => {
    const result = await axios.get<ICarrier>(`${API}/${id}`);
    return result.data;
};

export const updateCarrier = async (id: number, data: ICarrierUpdate) => {
    const result = await axios.put<ICarrier>(`${API}/${id}`, data);
    return result.data;
};

export const deleteCarrier = async (id: number) => {
    const result = await axios.delete<void>(`${API}/${id}`);
    return result.data;
};
